import React, { useState, useContext, useEffect } from 'react';

// Components
import SearchStreams from '../components/Streams/SearchStreams';
import SignUpForm from '../components/Form/SignUpForm';
import { ApiContext } from '../context/api/apiContext';
import ArtistList from '../components/Artist/ArtistList';
import { sortByQuery } from '../utils/index';

// Assets
import ArrowLeft from '../i/icons/decor_arrow_left.svg';

export const Streams = () => {
	const [searchInputValue, setSearchInputValue] = useState('');
	const [filteredChannels, setFilteredChannels] = useState([]);
	const [searchInputError, setSearchInputError] = useState('');
	const [notFoundSearchResult, setNotFoundSearchResult] = useState(false);
	const [searchResult, setSearchResult] = useState(null);
	const { channels, getAllChannels, jsonData } = useContext(ApiContext);

	const {
		heroSection,
		howStreamInWorksSection,
		signUpSection
	} = jsonData.pages.streams;

	const setAllChannels = async () => {
		const resChannels = await getAllChannels();

		setFilteredChannels(resChannels);
	};

	const backToAllChannels = () => {
		setFilteredChannels(channels);
		setSearchResult('');
	};

	const handleOnChange = e => {
		setSearchInputValue(e.target.value);
	};

	const validate = () => {
		if (!searchInputValue.trim().length) {

			setSearchInputError('The field must not be empty');
			return false;
		}

		return true;
	};

	const sortChannels = query => {
		const newQuery = query.toLowerCase().trim();
		const sortedArray = sortByQuery(channels, newQuery);

		if (sortedArray.length) {
			setSearchResult(query.trim());
			setNotFoundSearchResult('');
			setFilteredChannels(sortedArray);
		} else {
			setNotFoundSearchResult('No results...');
		}

	};

	const handleSubmit = e => {
		e.preventDefault();

		const isValid = validate();

		if (isValid) {
			sortChannels(searchInputValue);
			setSearchInputError('');
			setSearchInputValue('');
		}

	};

	useEffect(() => {
		setAllChannels();
	}, []);

	return (
		<React.Fragment>
			<section className="section hero_v1_mod center_level_mod bottom_decor_mod">
				<div className="section_bg loaded_mod" style={{ backgroundImage: `url(${heroSection.bgImage})` }} />
				<div className="section_in">
					<h2 className="section_title center_level_mod hero_v1_mod">{heroSection.title}</h2>
					<SearchStreams
						handleSubmit={handleSubmit}
						searchInputValue={searchInputValue}
						handleOnChange={handleOnChange}
						searchInputError={searchInputError}
						inputPlaceHolderValue={heroSection.inputPlaceHolderValue}
						formNote={heroSection.formNote}
					/>
				</div>
			</section>
			<section className="section">
				<div className="section_in">
					<div className="tab_content active_tab">
						{!notFoundSearchResult ? (
							<React.Fragment>
								{searchResult ? (
									<React.Fragment>
										<button
											className="btn_back"
											onClick={backToAllChannels}
										>
											<ArrowLeft className="btn_back_arrow"/>
											{searchSection.backBtnTitle}
										</button>
										<div className="artists_head">
											<div className="section_descr accent_mod upper_mod">{`Showing ${filteredChannels.length} results for`}</div>
											<div className="section_title accent_mod">{searchResult}</div>
										</div>
									</React.Fragment>
								) : null}
								<ArtistList
									channels={filteredChannels}
								/>
							</React.Fragment>
						) : (
								<div className="search_result_note">{notFoundSearchResult}</div>
							)}
					</div>
				</div>
			</section>
			<section className="section no_offset_top">
				<div className="section_in">
					<SignUpForm
						title={signUpSection.title}
						buttonTitle={signUpSection.buttonTitle}
					/>
				</div>
			</section>
			<section className="section info_mod double_decor_mod center_level_mod offset_mod">
				<div className="section_bg loaded_mod" style={{ backgroundImage: `url(${howStreamInWorksSection.bgImage})` }} />
				<div className="section_in">
					<div className="section_block center_level_mod limit_v1_mod">
						<h2 className="section_title offset_mod">{howStreamInWorksSection.title}</h2>
						<div className="section_descr offset_mod darken_mod">{howStreamInWorksSection.description}</div>
						<a className="btn_base" href={howStreamInWorksSection.buttonUrl}>{howStreamInWorksSection.buttonTitle}</a>
					</div>
				</div>
			</section>
		</React.Fragment>
	);
}
export default Streams;